import { QIcon_chevron_left } from '@repo/icons/index'
import classNames from 'classnames'
import { ReactElement } from 'react'
import { COLORS } from '../../../modules/vars'

export default function SliderPrevBtn({
  onClick,
  left = '-6px',
  top = '50%',
  right = 'auto',
  width,
  height,
}: {
  onClick?: any
  left?: string | number
  top?: string | number
  right?: string
  width?
  height?
}): ReactElement {
  return (
    <div
      className={classNames(
        onClick === null
          ? 'hidden'
          : 'absolute top-1/2 z-10 flex -translate-y-24 -translate-x-6 transform cursor-pointer items-center justify-center rounded-full bg-white shadow-[0_1px_6px_0_rgba(0,0,0,0.20)]'
      )}
      style={{ width: width ? width : '40px', height: height ? height : '40px', left, top, right }}
      onClick={onClick}
    >
      <div className="flex h-full w-full items-center justify-center">
        <QIcon_chevron_left width={20} height={20} color={COLORS.GRAY700} />
      </div>
    </div>
  )
}
